import * as AccessibleIcon from '@radix-ui/react-accessible-icon'

export default (props: AccessibleIcon.AccessibleIconProps) => <AccessibleIcon.Root {...props} />
